import { Editor, Extension } from '@tiptap/react';
import Suggestion from '@tiptap/suggestion';

export const SlashExtension = Extension.create({
  name: 'slash',

  addProseMirrorPlugins() {
    let firstFailedLookupQuery: string | null = null;

    return [
      Suggestion({
        editor: this.editor,
        decorationClass: 'slash-command-extension',
        allowSpaces: true,
        char: '/',

        command: ({
          editor,
          range,
          props,
        }: {
          editor: Editor;
          range: Range;
          props: any;
        }) => {
          props.command({ editor, range });
        },

        // Hide suggestion if no items found for 3 times in a row
        shouldShow: ({ editor, query }) => {
          const resolvedItems = this.options.suggestion.items({
            query,
            editor,
          });

          if (resolvedItems.items.length === 0) {
            if (!firstFailedLookupQuery) {
              firstFailedLookupQuery = query;
            } else if (query.length - firstFailedLookupQuery.length >= 2) {
              return false;
            }
          } else {
            firstFailedLookupQuery = null;
          }

          return true;
        },

        ...this.options.suggestion,
      }),
    ];
  },
});
